import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import { X } from "@phosphor-icons/react";

import { Diagram } from "@/types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  diagram: Diagram;
}

const DiagramModal = ({ isOpen, onClose, diagram }: Props) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
    >
      <DialogTitle
        sx={{
          px: 3,
          py: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="text14B">
          {diagram.title}
        </Typography>
        <IconButton
          aria-label="Close diagram dialog"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: -24,
            right: -24,
            color: "common.white",
          }}
        >
          <X size={18} weight="bold" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <img
          src={diagram.imageUrl}
          alt={diagram.title}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
        />
        <Typography variant="body2" color="text.secondary" mt={2}>
          {diagram.description}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default DiagramModal;
